import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { registerLocaleData } from '@angular/common';
import localeKo from '@angular/common/locales/ko';
import localeFr from '@angular/common/locales/fr';

registerLocaleData(localeKo);
registerLocaleData(localeFr);

bootstrapApplication(App, appConfig).catch((err) => console.error(err));
